import React from 'react'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const MapWithAMarker = withScriptjs(withGoogleMap(props =>
  <GoogleMap
    defaultZoom={10}
    defaultCenter={{ lat: -38.2317124, lng: 146.4146 }}
    onClick={e => console.log(e.latLng.lat(), e.latLng.lng())}
  >
  {props.QualityPlans.map((x) =>
    <Marker key={x.id} position={{ lat: x.latitude, lng: x.longitude }}>
    </Marker>)
  }


  </GoogleMap>
));

export default MapWithAMarker;
